import { Component, OnInit } from "@angular/core";
import { WinService } from "src/app/services/win.service";
import { OwlOptions } from "ngx-owl-carousel-o";
import { MainService } from "src/app/services/api/main.service";

@Component({
  selector: "app-article",
  templateUrl: "./article.component.html",
  styleUrls: ["./article.component.scss"],
})
export class ArticleComponent implements OnInit {
  reviews: any = null;

  customOptions: OwlOptions = {
    loop: true,
    nav: false,
    dots: false,
    navSpeed: 1000,
    items: 1,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    responsive: {
      0: { items: 1 },
      400: { items: 1 },
      740: { items: 1 },
      940: { items: 1 },
    },
  };

  constructor(public winService: WinService, public mainService: MainService) {}

  ngOnInit() {
    this.getReview(12).then((rev12) => {
      this.getReview(21).then((rev21) => {});
    });
  }

  getReview(productId: any) {
    return new Promise((res) => {
      this.mainService
        .get(
          "/rest/entrelable/V1/lns-api/product/review/" +
            productId +
            "/?page=1&pageSize=20"
        )
        .subscribe((reviews) => {
          let rev: any = reviews[0].data;
          if (rev.length) {
            if (!this.reviews) {
              this.reviews = [];
            }
            this.reviews = rev;
          }
          res(true);
        });
    });
  }

  /**
   * return the src of the image for sart ratings
   * @param currentStart
   */
  getStartIcon(currentStart, ratingStart) {
    let cs: any = parseInt(currentStart);
    let rs: any = parseInt(ratingStart);
    if (rs >= cs) {
      return "./assets/icons/star-solid.png";
    } else {
      return "./assets/icons/star-blank.png";
    }
  }
}
